import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { messagesType } from '../propTypes';

const MessageContext = createContext();

export const useMessageContext = () => useContext(MessageContext);

export const MessageContextProvider = ({ children, messages, setMessages }) => {
  const value = useMemo(
    () => ({ messages, setMessages }),
    [messages, setMessages],
  );
  return (
    <MessageContext.Provider value={value}>{children}</MessageContext.Provider>
  );
};
MessageContextProvider.propTypes = {
  messages: messagesType,
  setMessages: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
